module.exports = __locale;


//////////////////
// WEBPACK FOOTER
// external "__locale"
// module id = +yFt
// module chunks = 2